import { Loader2 } from 'lucide-react';

export default function BookingLoadingOverlay({ message = 'Processing your booking…' }) {
  return (
    <div className="booking-loading" role="status" aria-live="polite">
      <Loader2 size={40} className="spin" aria-hidden />
      <p>{message}</p>
    </div>
  );
}
